// src/components/menu.ts

export const getMenuOptions = (userRole: string) => {
  const menu = [
    {
      section: "Operaciones",
      items: [
        { name: "Dashboard", icon: "📊", path: userRole === 'CAJERO' ? '/cajero/panel' : '/admin/dashboard', show: true }
      ]
    },
    {
      section: "Supervisión",
      items: [
        { name: "Reportes", icon: "📈", path: "/admin/reportes", show: userRole === 'ADMIN' || userRole === 'SUPERVISOR' },
        { name: "Auditoría de Cierres", icon: "🗂️", path: "/admin/cierres", show: userRole === 'ADMIN' || userRole === 'SUPERVISOR' },
        { name: "Cartera y Deudores", icon: "📓", path: "/admin/deudores", show: userRole === 'ADMIN' || userRole === 'SUPERVISOR' },
        { name: "Asistencia y Nómina", icon: "⏱️", path: "/admin/asistencia", show: userRole === 'ADMIN' || userRole === 'SUPERVISOR' }
      ]
    },
    {
      section: "Administración",
      items: [
        { name: "Agencias", icon: "🏢", path: "/admin/agencias", show: userRole === 'ADMIN' },
        { name: "Usuarios y Accesos", icon: "👥", path: "/admin/usuarios", show: userRole === 'ADMIN' },
        { name: "Servicios y Asignaciones", icon: "🎰", path: "/admin/plataformas", show: userRole === 'ADMIN' },
        { name: "Cuentas Bancarias", icon: "🏦", path: "/admin/cuentas", show: userRole === 'ADMIN' },
        { name: "Seguridad y Logs", icon: "🛡️", path: "/admin/seguridad", show: userRole === 'ADMIN' },
        // 💡 NUEVO BOTÓN AÑADIDO:
        { name: "Importador Simulación", icon: "🤖", path: "/admin/importador", show: userRole === 'ADMIN' },
        { name: "Configuración General", icon: "⚙️", path: "/admin/configuracion", show: userRole === 'ADMIN' },
      ]
    }
  ];

  return menu
    .map(group => ({ ...group, items: group.items.filter(item => item.show) }))
    .filter(group => group.items.length > 0); 
};